import produce from 'immer';

import { InternalGroupsFieldValidationErrorsDropAction } from '../../actions/internalGroups/dropInternalGroupsFieldValidationErrors';
import { EditGroupsState } from '../../typings/groupsEditState';

export const dropInternalGroupsFieldValidationErrors = (
    state: EditGroupsState,
    action: InternalGroupsFieldValidationErrorsDropAction
): EditGroupsState => {
    const { groupId, fieldName } = action;

    return produce(state, draft => {
        delete draft.groups[groupId].errors[fieldName];
    });
};
